import { createContext } from 'react';

export const ColorModeContext = createContext({ toggleColorMode: () => { }, currentMode: 'light' as 'light' | 'dark' });
